import { render, staticRenderFns } from "./refundInfo.vue?vue&type=template&id=1ceea5cd&scoped=true&"
import script from "./refundInfo.vue?vue&type=script&lang=js&"
export * from "./refundInfo.vue?vue&type=script&lang=js&"
import style0 from "./refundInfo.vue?vue&type=style&index=0&id=1ceea5cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceea5cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ceea5cd')) {
      api.createRecord('1ceea5cd', component.options)
    } else {
      api.reload('1ceea5cd', component.options)
    }
    module.hot.accept("./refundInfo.vue?vue&type=template&id=1ceea5cd&scoped=true&", function () {
      api.rerender('1ceea5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/detail/components/refundInfo.vue"
export default component.exports